// Tag for graphql format
const gql = String.raw;

const InputValueFragment = gql`
	fragment InputValue on InputValue {
		input
		value
	}
`;

const MiniDealsFragment = gql`
	fragment MiniDeals on MiniDeals {
		mini {
			...InputValue
		}
		cap {
			...InputValue
		}
		capEnabled
	}
	${InputValueFragment}
`;

const ModelYearsFragment = gql`
	fragment ModelYears on ModelYears {
		rangeType
		left
		right
	}
`;

const DefaultProductTierFragment = gql`
	fragment DefaultProductTier on DefaultProductTier {
		input
		value
		product
	}
`;

const DefaultCommissionsTierFragment = gql`
	fragment DefaultCommissionsTier on DefaultCommissionsTier {
		from {
			...InputValue
		}
		to {
			...InputValue
		}
		frontGross {
			...InputValue
		}
		backGross {
			...InputValue
		}
		frontProducts {
			...DefaultProductTier
		}
		backProducts {
			...DefaultProductTier
		}
	}
	${DefaultProductTierFragment}
`;

const SpecialUnitsRuleFragment = gql`
	fragment SpecialUnitsRule on SpecialUnitsRule {
		make
		model
		regularExpression
		applyTiersRetroactively
		modelYears {
			...ModelYears
		}
		miniDeal {
			...MiniDeals
		}
		tiers {
			...DefaultCommissionsTier
		}
	}
	${MiniDealsFragment}
	${ModelYearsFragment}
	${DefaultCommissionsTierFragment}
`;

const SpecialRuleDefinitionFragment = gql`
	fragment SpecialRuleDefinition on SpecialRuleDefinition {
		definitions {
			...SpecialUnitsRule
		}
		totalSpecialUnits
	}
	${SpecialUnitsRuleFragment}
`;

const SpecialUnitsRulesFragment = gql`
	fragment SpecialUnitsRules on SpecialUnitsCommissionRules {
		new {
			...SpecialRuleDefinition
		}
		preOwned {
			...SpecialRuleDefinition
		}
		globalUnitCounts
	}
	${SpecialRuleDefinitionFragment}
`;

export { SpecialUnitsRulesFragment };
